const Roles = {
  STUDENT: 'student',
  COACH: 'coach',
  EDITOR: 'editor',
  HALF_ADMIN: 'half_admin',
  ADMIN: 'admin'
};

export default Roles;
